import { render, staticRenderFns } from "./AssetTypeModal.vue?vue&type=template&id=1f6f6263"
import script from "./AssetTypeModal.vue?vue&type=script&lang=js"
export * from "./AssetTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports